import * as CONSTANTS from "./constants";

export class EdgeData {
    /** edge status can be either UP or DOWN */
    status;

    constructor() {}

    /**
     * build EdgeData
     * @param {string} status = UP 
     * @return {EdgeData}
     */
    static build(status = CONSTANTS.UP) {
        let instance = new EdgeData();
        instance.status = status;
        return instance;
    }

    /** See import statement in Session.js for more information */
    import(data) {
        for (let key in data) {
            this[key] = data[key];
        }
    }

    /** create new EdgeData from @param data and return it
     * @param data
     * @return {EdgeData}
     */
    newFromData(data) {
        let instance = new EdgeData();
        instance.import(data);
        return instance;
    }

    toJSON() {
        return {
            status: this.status
        };
    }

    static jsonDeserialize(jsonString) {
        let data = jsonString;
        return EdgeData.build(data.status);
    }
}